/**
 * Companion module for expandable element components (expandable_element.html.twig).
 */

/**
 * Toggles the open state of a details element with smooth animation.
 *
 * @param {HTMLDetailsElement} details - The details element to toggle.
 * @param {HTMLElement} content - The content element to animate.
 */
function toggleDetails(details, content) {
  // Generally, we want to avoid styling in js files and use scss instead.
  // However, using CSS classes does not work with the animation.

  if (details.open) {
    // Closing animation
    const startHeight = content.scrollHeight;
    content.style.height = startHeight + 'px';
    content.style.opacity = '1';

    requestAnimationFrame(() => {
      content.style.transition = 'height 0.2s ease-out, opacity 0.3s ease-out';
      content.style.height = '0px';
      content.style.opacity = '0';
    });

    setTimeout(() => {
      details.removeAttribute('open');
      content.style.height = '';
      content.style.opacity = '';
      content.style.transition = '';
    }, 300);
  } else {
    // Opening animation

    content.style.height = '0px';
    content.style.opacity = '0';
    content.style.transition = 'height 0.2s ease-out, opacity 0.3s ease-in';
    details.setAttribute('open', '');
    const endHeight = content.scrollHeight;

    requestAnimationFrame(() => {
      content.style.height = endHeight + 'px';

      // Delay opacity for a nicer fade-in effect
      setTimeout(() => {
        content.style.opacity = '1';
      }, 50);
    });

    setTimeout(() => {
      content.style.height = '';
      content.style.opacity = '';
      content.style.transition = '';
    }, 500);
  }
}

/**
 * Initializes expandable elements within a container.
 *
 * @param {HTMLElement} container - The container element to search for expandable elements.
 */
function initializeExpandable(container) {
  container.querySelectorAll('.js_expandable_element').forEach((element) => {
    const details = element.querySelector('details');
    const summary = element.querySelector('summary');
    const content = element.querySelector('.js_expandable_content');

    if (!details || !summary || !content) {
      return;
    }

    summary.addEventListener('click', function (e) {
      // Remove default behavior
      e.preventDefault();
      toggleDetails(details, content);
    });

    // Allow closing by clicking on content (but not on links).
    content.addEventListener('click', function (e) {
      // Do not close if clicking on a link or an element inside a link.
      if (e.target.tagName === 'A' || e.target.closest('a')) {
        return;
      }

      if (details.open) {
        toggleDetails(details, content);
      }
    });
  });
}

// Export functions for use in other modules
export { toggleDetails, initializeExpandable };
